<template lang='pug'>
  div.visualization
    //- ods-tabs(v-model='tabsGeneric' @tab-click="handleClick" v-loading='!!!loading && dataVisualizations')
    //-   ods-tab-pane(v-for='(item, index) in dataVisualizations' :name='item.url' :label='item.name' :key='index')
    div.visualization__statuscero(v-if='dataVisualizations && !dataVisualizations.length')
      StatusCero(
        :title='$t("noResults")'
        :description='$t("noVisualizationData")'
      )
    template(v-else)
      div.tabs__header
        carousel(
          v-if='carouselTabs'
          :perPageCustom='[[768, 3], [1024, 6], [1200, 6]]'
          :scrollPerPage='true'
          :paginationEnabled='false'
          :navigationEnabled='true'
          :navigationClickTargetSize='10'
          navigationNextLabel='<em class="ods-icon-arrow-right"></em>'
          navigationPrevLabel='<em class="ods-icon-arrow-left"></em>'
        )
          slide.tabs__item(ref="tabsItem" v-for='(item, index) in dataVisualizations' :key='index' :class="{active:item.name == active}" @click='cambioClick(item)') {{item.name}}
        div(v-else)
          span.tabs__item(ref="tabsItem" v-for='(item, index) in dataVisualizations' :key='index' :class="{active:item.name == active}" @click='cambioClick(item)') {{item.name}}
      template(v-if='cambio')
        object(:data='url')
</template>

<script>

// import ObjectMap from '@/components/ObjectMap'
import { Carousel, Slide } from 'vue-carousel'
import StatusCero from '@/components/StatusCero'

// let myLoadElem = null

export default {
  name: 'VisualizationDashboard',
  data () {
    return {
      // tabsGeneric: '',
      dataVisualizations: [],
      windowWidth: 0,
      tabsLength: '',
      carouselTabs: false,
      cambio: false,
      active: undefined,
      url: ''
    }
  },
  computed: {
    getListVisualization () {
      return this.$store.getters.getListVisualization
    }
  },
  watch: {
    getListVisualization (val) {
      const component = this
      if (val) {
        component.dataVisualizations = val
        component.cambioClick(component.dataVisualizations[0])
        component.tabsLength = component.dataVisualizations.length
        window.addEventListener('resize', component.setCarouselOptions)
        component.setCarouselOptions()
        // this.tabsGeneric = this.dataVisualizations[0].url
        // var myLoadElem = setInterval(myLoadMap, 500)
        // function myLoadMap () {
        //   if (component.$refs.objectMap !== null) {
        //     let objectArr = component.$refs.objectMap
        //     for (var i = 0; i < objectArr.length; i++) {
        //       let url = component.tabsGeneric
        //       objectArr[i].detailView(url)
        //       clearInterval(myLoadElem)
        //     }
        //   }
        // }
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('updateListVisualization')
    },
    rerender (callback) {
      this.$nextTick(() => {
        callback()
      })
    },
    cambioClick (val) {
      this.url = val.url
      this.active = val.name
      // this.active = this.$refs.tabsItem[i].textContent
      this.cambio = false
      this.rerender(() => {
        this.cambio = true
      })
    },
    setCarouselOptions (event) {
      const component = this
      component.windowWidth = document.documentElement.clientWidth
      if (component.tabsLength >= 8 && component.windowWidth <= 1300) {
        component.carouselTabs = true
      } else {
        component.carouselTabs = false
      }
    }
    // controlLoad () {
    //   const component = this
    //   myLoadElem = setInterval(myLoadMap, 500)
    //   let object = component.$refs.objectMap
    //   function myLoadMap () {
    //     for (var i = 0; i < object.length; i++) {
    //       if (component.$refs.objectMap[i].getLoad() === true) {
    //         component.loading = true
    //         clearInterval(myLoadElem)
    //       }
    //     }
    //   }
    // },
    // handleClick (tab, event) {
    //   let objectArr = this.$refs.objectMap
    //   this.loading = false
    //   // this.controlLoad()
    //   for (var i = 0; i < objectArr.length; i++) {
    //     let url = this.tabsGeneric
    //     objectArr[i].detailView(url)
    //   }
    // }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setCarouselOptions)
  },
  components: {
    // ObjectMap
    StatusCero,
    Carousel,
    Slide
  }
}
</script>

<style lang='scss' scoped>

  .visualization{

    &__statuscero {
      display: flex;
      align-items: center;
      height: 100vh;
      justify-content: center;
      align-content: center;
    }

    .tabs__header{
      box-sizing: border-box;
      background: $--color-primary-light-9;
      margin-bottom: 0;
      min-height: rem(64);
      padding: rem(12) rem(48) rem(12) rem(48);
      > div{
        margin-top: rem(6);
      }
    }
    .tabs__item{
      box-sizing: border-box;
      color: #000;
      cursor: pointer;
      display: inline-block;
      font-size: 10px;
      font-weight: 500;
      line-height: 1;
      list-style: none;
      margin: 0 rem(16);
      padding: 0 0 rem(16) 0;
      position: relative;
      text-transform: uppercase;
      &.active{
        color: $--color-primary;
      }
      &:hover{
        color: $--color-primary;
      }
      &.active::after{
        content: '';
        background-color: $--color-primary;
        bottom: 0;
        height: 2px;
        left: 0;
        list-style: none;
        position: absolute;
        transition: transform .3s cubic-bezier(.645,.045,.355,1);
        width: 100%;
        z-index: 1;
      }
    }

    /deep/ .VueCarousel{
      margin-top: rem(12);

      &-wrapper{
        margin: 0 auto;
        width: 98%;
      }
      &-slide {
        flex-basis: auto !important;
        padding-right: rem(12);
      }
      &-navigation-prev{
        left: rem(12);
        top: 35%;
      }
      &-navigation-next{
        right: rem(12);
        top: 35%;
      }
    }

    object {
      height: calc(100vh - 165px);
      width: 100%;
    }
  }

  // .visualization{
    // position: relative;
    // /deep/ .ods-tabs__content{
    //   min-height: 80vh;
    // }
    // /deep/ .ods-loading-mask{
    //   bottom: inherit;
    //   top: 50%;
    // }
    // .ods-button{
    //   float: right;
    //   position: absolute;
    //   right: 4%;
    //   top: rem(30);
    //   z-index: 10;
    // }
  // }

  // /deep/ .ods-tabs{
  //   &__nav-wrap.is-scrollable{
  //     padding: 0 rem(48);
  //     width: 88%;
  //   }
  //   &__header{
  //     background: $--color-primary-light-9;
  //     margin-bottom: 0;
  //     min-height: rem(50);
  //     padding: rem(24) rem(64);
  //   }
  //   &__item{
  //     padding: rem(16) rem(24);
  //   }
  // }

</style>



// WEBPACK FOOTER //
// src/views/VisualizationDashboard.vue